
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinkurkumbh() {



const cardData = {
  keyword: 'Cab Service in Kurkumbh MIDC',
  heading: 'eTravo: Dependable Corporate Cab Services in Kurkumbh MIDC for Smooth Industrial Transport',
  headingDescription: 'eTravo offers top-tier corporate cab services in Kurkumbh MIDC, tailored to meet the dynamic transportation requirements of industrial units, employees, and executives in this bustling industrial zone. Our fleet comprises GPS-enabled, air-conditioned vehicles driven by trained professionals to ensure safety, punctuality, and comfort. Whether you need reliable daily staff commutes, executive transfers, or client transport, eTravo delivers flexible, scalable, and efficient solutions designed to optimize your corporate travel experience in Kurkumbh MIDC and surrounding areas.',

  top: 'Prominent Industrial and Business Locations in Kurkumbh MIDC Served by eTravo',
  topPlaces: [
    {
      title: 'Kurkumbh Industrial Estate',
      description: 'The heart of Kurkumbh MIDC, hosting numerous manufacturing and industrial plants. eTravo’s corporate cab services facilitate smooth transport for employees across various shifts, ensuring timely arrivals and departures.'
    },
    {
      title: 'Pharmaceutical Manufacturing Units',
      description: 'Kurkumbh MIDC is known for several pharmaceutical companies requiring meticulous transportation for staff and executives. Our cabs ensure comfortable and reliable travel compliant with industry standards.'
    },
    {
      title: 'Automotive Component Plants',
      description: 'Specialized transport solutions for automotive sector employees working in Kurkumbh, supporting shift-wise schedules and multi-stop routes to optimize workforce logistics.'
    },
    {
      title: 'Logistics and Warehousing Centers',
      description: 'Our cab services assist logistics personnel and management with timely and secure transportation to and from Kurkumbh’s warehousing hubs.'
    },
    {
      title: 'Kurkumbh Bus Stop and Local Transit Points',
      description: 'Providing first-mile and last-mile connectivity for employees relying on public transport, enhancing overall commute efficiency.'
    },
    {
      title: 'Nearby Residential Areas',
      description: 'Facilitating convenient and comfortable transport from residential complexes to industrial sites, supporting employee punctuality and work-life balance.'
    },
    {
      title: 'Training and Development Centers',
      description: 'Transport solutions for employees attending training sessions, workshops, and certification programs within the industrial area.'
    },
    {
      title: 'Corporate Offices in Kurkumbh',
      description: 'Dedicated cab services for office staff, executives, and visiting clients to support business continuity and professional corporate travel.'
    },
    {
      title: 'Nearby Educational Institutes',
      description: 'Providing reliable transport for visiting faculty, trainees, and corporate guests to educational and vocational institutions in Kurkumbh MIDC.'
    },
    {
      title: 'Healthcare Facilities',
      description: 'Ensuring safe and prompt transport for employees and clients accessing healthcare services within and around Kurkumbh MIDC.'
    }
  ],

  services: [
    {
      name: 'Kurkumbh MIDC Corporate Cab Rentals',
      description: 'Flexible and customizable corporate cab rental plans designed for industries of all sizes in Kurkumbh MIDC. Options include long-term contracts and on-demand rentals tailored to business needs.'
    },
    {
      name: 'Employee Transport Cab Kurkumbh MIDC',
      description: 'Comprehensive employee transport services with GPS-enabled vehicles, professional drivers, and multi-stop routes, ensuring timely and secure commutes across shifts.'
    },
    {
      name: 'Business Cab Services Kurkumbh MIDC',
      description: 'Efficient and reliable cab services for business owners, field agents, and client visits, featuring a diverse fleet including sedans, SUVs, and executive cars.'
    },
    {
      name: 'Corporate Staff Cabs Kurkumbh MIDC',
      description: 'Structured staff transportation solutions with shift-based scheduling, real-time vehicle tracking, and adaptable pickup/drop points to maximize operational efficiency.'
    },
    {
      name: 'Reliable Corporate Cab Service Kurkumbh MIDC',
      description: 'Renowned for punctuality, clean and well-maintained vehicles, and professional chauffeurs committed to seamless daily corporate travel.'
    },
    {
      name: 'AC Corporate Cabs Kurkumbh MIDC',
      description: 'All vehicles are air-conditioned and sanitized, providing a comfortable environment suitable for hot climates and long commutes typical of industrial zones.'
    },
    {
      name: 'Staff Pickup and Drop Cab Kurkumbh MIDC',
      description: '24/7 pickup and drop services catering to multiple shifts and departments, designed to reduce employee commute stress and enhance productivity.'
    },
    {
      name: 'Affordable Business Cab Rentals Kurkumbh MIDC',
      description: 'Competitive pricing with flexible billing and contract terms to suit businesses of all sizes looking for cost-effective transportation.'
    },
    {
      name: 'Executive Cab Services Kurkumbh MIDC',
      description: 'Premium cab services with top-tier vehicles and well-groomed chauffeurs, perfect for executives, VIP clients, and special corporate events.'
    },
    {
      name: 'Monthly Corporate Cab Rentals Kurkumbh MIDC',
      description: 'Comprehensive monthly rental plans that include route optimization, real-time tracking, and priority customer support for uninterrupted service.'
    },
    {
      name: 'Industrial Area Employee Transport Kurkumbh MIDC',
      description: 'End-to-end employee transport solutions tailored to industrial shift patterns, including multi-stop pickups, ensuring safe and reliable commutes.'
    },
    {
      name: 'Corporate Client Cabs Kurkumbh MIDC',
      description: 'Professional cab services designed for client visits, business meetings, and corporate hospitality, promoting a positive corporate image.'
    },
    {
      name: 'Business Meeting Cabs Kurkumbh MIDC',
      description: 'On-demand, flexible cab services ensuring quick and comfortable travel for business meetings, site inspections, and urgent client requirements.'
    },
    {
      name: 'Kurkumbh Industrial Area Cab Hire',
      description: 'Dedicated cab hire options for staff transportation, special events, and inter-office travel with scalable fleet availability and customizable plans.'
    },
    {
      name: 'Corporate Shuttle Cabs Kurkumbh MIDC',
      description: 'Group shuttle services designed to efficiently transport teams between industrial units, offices, transit hubs, and residential areas within Kurkumbh MIDC.'
    }
  ],

  tableData: [
    ['Kurkumbh MIDC Corporate Cab Rentals', 'Employee Transport Cab Kurkumbh MIDC'],
    ['Business Cab Services Kurkumbh MIDC', 'Corporate Staff Cabs Kurkumbh MIDC'],
    ['Reliable Corporate Cab Service Kurkumbh MIDC', 'AC Corporate Cabs Kurkumbh MIDC'],
    ['Staff Pickup and Drop Cab Kurkumbh MIDC', 'Affordable Business Cab Rentals Kurkumbh MIDC'],
    ['Executive Cab Services Kurkumbh MIDC', 'Monthly Corporate Cab Rentals Kurkumbh MIDC'],
    ['Industrial Area Employee Transport Kurkumbh MIDC', 'Corporate Client Cabs Kurkumbh MIDC'],
    ['Business Meeting Cabs Kurkumbh MIDC', 'Kurkumbh Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Kurkumbh MIDC', '']
  ],


"whychoose": [
    {
        "WhyChooseheading": "Customized Corporate Cab Services for Kurkumbh MIDC",
        "WhyChoosedescription": "eTravo provides tailor-made cab services specifically designed to meet the transportation needs of businesses operating in Kurkumbh Industrial Area MIDC. Our focus is on delivering reliable, punctual, and comfortable rides that help enhance employee productivity and reduce the stress of daily commuting in this growing industrial hub."
    },
    {
        "WhyChooseheading": "Versatile Fleet to Accommodate Corporate Travel Requirements",
        "WhyChoosedescription": "Our fleet consists of a diverse range of vehicles, including sedans, SUVs, and MUVs, allowing companies to select the most suitable option for employee commutes, client visits, or inter-office travel within Kurkumbh MIDC and neighboring areas."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Kurkumbh MIDC Routes",
        "WhyChoosedescription": "Our drivers are trained professionals with extensive knowledge of Kurkumbh MIDC’s roads and traffic conditions. Their expertise ensures efficient navigation and adherence to schedules, minimizing delays and providing a dependable travel experience."
    },
    {
        "WhyChooseheading": "Flexible Booking Options Designed for Corporate Convenience",
        "WhyChoosedescription": "We offer a variety of booking solutions such as on-demand rides, advance scheduling, and long-term contracts, allowing businesses to manage transportation according to their dynamic operational requirements."
    },
    {
        "WhyChooseheading": "Real-Time GPS Tracking for Enhanced Safety and Monitoring",
        "WhyChoosedescription": "Each vehicle is equipped with GPS tracking technology, enabling corporate clients to monitor employee journeys in real-time, ensuring safety, accountability, and prompt responses to any travel disruptions."
    },
    {
        "WhyChooseheading": "Transparent Billing with Detailed Invoices for Easy Management",
        "WhyChoosedescription": "Our billing process is clear and detailed, providing itemized invoices that include trip logs and fare breakdowns, simplifying expense tracking and reimbursement for corporate finance teams."
    },
    {
        "WhyChooseheading": "Commitment to Safety and Hygiene Standards",
        "WhyChoosedescription": "We prioritize passenger health by regularly sanitizing vehicles and enforcing strict hygiene protocols for drivers, including mask usage and hand sanitization, ensuring a safe travel environment."
    },
    {
        "WhyChooseheading": "Dedicated Account Management for Personalized Corporate Support",
        "WhyChoosedescription": "Corporate clients benefit from having a dedicated account manager who assists with bookings, addresses queries promptly, and tailors transportation solutions to meet specific business needs."
    }
]
}

const faqData = [
    [
        {
            question: "Which areas do you cover with your cab services in Kurkumbh MIDC?",
            answer: "Our service area includes Kurkumbh Industrial Area MIDC and nearby locations such as Saswad, Pune Industrial zones, and surrounding commercial hubs."
        },
        {
            question: "Is it possible to schedule regular rides for employees?",
            answer: "Yes, we offer scheduling options for recurring rides to ensure consistent and timely transportation for your workforce."
        },
        {
            question: "Do you provide monthly billing options for corporate clients?",
            answer: "Yes, we offer monthly billing with detailed invoices to streamline your company's expense management."
        },
        {
            question: "Are your drivers trained to uphold corporate etiquette?",
            answer: "All our drivers undergo professional training to maintain high standards of courtesy, professionalism, and safety."
        },
        {
            question: "What safety measures are in place during rides?",
            answer: "We utilize GPS tracking, regular vehicle maintenance, and enforce strict hygiene protocols including sanitization and mask-wearing."
        },
        {
            question: "Is dedicated support available for corporate clients in Kurkumbh MIDC?",
            answer: "Yes, our corporate clients have access to dedicated account managers and support teams for prompt assistance."
        }
    ]
];

const testimonialsData = [
    {
        name: "Mr. Sameer Kulkarni",
        designation: "Operations Manager, Kurkumbh Industries",
        rating: [1, 1, 1, 1, 1],
        text: "“eTravo’s cab service has greatly improved our employee commute efficiency in Kurkumbh MIDC. The service is reliable, punctual, and professional.”"
    },
    {
        name: "Ms. Anjali Desai",
        designation: "HR Head, GreenTech Solutions",
        rating: [1, 1, 1, 1, 1],
        text: "“The safety protocols and dedicated support from eTravo make them our preferred corporate transportation partner in Kurkumbh.”"
    }
];


























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Kurkumbh MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-kurkumbh-midc.jpg",
  "description": "Reliable corporate cab service in Kurkumbh MIDC for employee transport, business meetings, and industrial commutes. Affordable AC corporate cabs with trusted drivers by eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "7523"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-kurkumbh-midc"
  }
};






    return (
        <div>

<Helmet>
  <title>Cab Service in Kurkumbh MIDC | Corporate & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire cab services in Kurkumbh MIDC for corporate staff transport, business meetings, and industrial area commutes. Affordable and reliable AC corporate cabs by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/58.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinkurkumbh;